import { useState } from "react"
import { FileWarning } from "lucide-react"
import { cn } from "@/lib/utils"

interface SafeImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
    onErrorStateChange?: (error: boolean) => void
}

export function SafeImage({ src, alt, className, onErrorStateChange, ...props }: SafeImageProps) {
    const [hasError, setHasError] = useState(false)

    const handleError = () => {
        setHasError(true)
        onErrorStateChange?.(true)
    }

    if (hasError || !src) {
        return (
            <div className={cn("flex flex-col items-center justify-center bg-muted/30 text-muted-foreground min-h-[100px]", className)}>
                <FileWarning className="h-8 w-8 mb-2 opacity-50" />
                <p className="text-[10px] font-black uppercase tracking-widest text-center px-4 leading-tight">Image Unavailable</p>
            </div>
        )
    }

    return (
        <img
            src={src}
            alt={alt}
            className={className}
            onError={handleError}
            {...props}
        />
    )
}
